import { queryOptions } from '@tanstack/react-query'
import { api } from '@/api/client'
import { queryKeys } from '@/lib/query-keys'

export interface User {
  id: number
  first_name: string | null
  last_name: string | null
  email: string
  email_verified_at: string | null
  locale: string | null
  created_at: string
}

export interface AuthTokenResponse {
  user: User
  access_token: string
  token_type: 'Bearer'
  expires_at: string | null
  expires_in: number | null
}

export interface LoginData {
  email: string
  password: string
}

export interface ForgotPasswordData {
  email: string
}

export interface ResetPasswordData {
  token: string
  email: string
  password: string
  password_confirmation: string
}

export async function login(email: string, password: string): Promise<AuthTokenResponse> {
  return api.post<AuthTokenResponse>('/auth/login', { body: { email, password } })
}

export async function forgotPassword(data: ForgotPasswordData): Promise<void> {
  return api.post<void>('/auth/forgot-password', { body: data })
}

export async function resetPassword(data: ResetPasswordData): Promise<AuthTokenResponse> {
  return api.post<AuthTokenResponse>('/auth/reset-password', { body: data })
}

export async function fetchCurrentUser(): Promise<User> {
  return api.get<User>('/auth/me')
}

export async function logout(): Promise<void> {
  return api.post<void>('/auth/logout')
}

export function meQueryOptions() {
  return queryOptions({
    queryKey: queryKeys.auth.me,
    queryFn: async () => fetchCurrentUser(),
  })
}

export interface UpdateProfileData {
  first_name: string
  last_name: string
  email: string
}

export interface UpdatePasswordData {
  current_password: string
  new_password: string
  new_password_confirmation: string
}

export async function updateProfile(data: UpdateProfileData): Promise<User> {
  return api.patch<User>('/auth/me', { body: data })
}

export async function updatePassword(data: UpdatePasswordData): Promise<void> {
  return api.put<void>('/auth/password', { body: data })
}
